import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Junta classes resolvendo conflito do Tailwind.
 *
 * Mesma funcao `cn` do CRM (`src/lib/utils.ts`), pelo mesmo motivo: com
 * `clsx` sozinho, `cn("p-2", "p-4")` produz as duas classes e qual vence depende
 * da ordem no CSS gerado. O `twMerge` sabe que `p-4` substitui `p-2`, entao o
 * `className` que o consumidor passa realmente sobrescreve o padrao do
 * componente — que e o comportamento que todo mundo espera.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(classes));
}
